module.exports = __webpack_public_path__ + "static/media/title.f9b82bd9.png";